import { useState } from "react";
import { toast } from "sonner";
import { Plus, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AppointmentFields, EMPTY_FORM, validateForm } from "@/components/AppointmentFields";
import { api, formatApiError } from "@/lib/api";

export const WalkInDialog = ({ onCreated }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const err = validateForm(form);
    if (err) return toast.error(err);
    setLoading(true);
    try {
      await api.post("/admin/appointments", { ...form, age: Number(form.age) });
      toast.success("Walk-in appointment added");
      setForm(EMPTY_FORM);
      setOpen(false);
      onCreated();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="rounded-full" data-testid="walkin-open-btn"><Plus className="mr-1 h-4 w-4" /> New appointment</Button>
      </DialogTrigger>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto" data-testid="walkin-dialog">
        <DialogHeader><DialogTitle>Add walk-in / phone booking</DialogTitle></DialogHeader>
        <form onSubmit={submit}>
          <AppointmentFields form={form} setForm={setForm} prefix="walkin" allowAnyDate />
          <Button type="submit" className="mt-6 w-full rounded-full" disabled={loading} data-testid="walkin-submit-btn">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Save appointment
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
